// In prodottiSlice.js
import { createSlice } from "@reduxjs/toolkit";
// import { singleProdotti } from "./prodottiThunk";

const initialState = {
  prodotti: [],
  singleProdotti:{},
  selectedProdottoId: null,
  isLoading: false,
  error: null,
  tipologia: [],  
  annoDiProduzione: [],
  tipo: [],
  denominazione: [],
  enumsLoading: {
    tipologia: false,
    tipo: false,
    denominazione: false,
    annoDiProduzione: false
  },
  enumsError: {
    tipologia: null,
    tipo: null,
    denominazione: null,
    annoDiProduzione: null,
  }
};

const prodottoSlice = createSlice({
  name: "prodottoData",
  initialState,
  reducers: {
    setProdotti: (state, action) => {
      state.prodotti = action.payload;
      console.log("setProdotti - New prodotti:", state.prodotti);
    },
    addProdotto: (state, action) => {
      state.prodotti.push(action.payload);
    },
    setSelectedProdottoId: (state, action) => {
      state.selectedProdottoId = action.payload;
    },    
    addProdottoId: (state, action) => {
      state.singleProdotti = action.payload;
    },
    updateProdotto: (state, action) => {
        const index = state.prodotti.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.prodotti[index] = action.payload;
        }
      },
    deleteProdotto: (state, action) => {
      state.prodotti = state.prodotti.filter(
        (item) => item.id !== action.payload
      );
    },
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setTipologia: (state, action) => {
      state.tipologia = action.payload;
    },
    setAnnoDiProduzione: (state, action) => {
      state.annoDiProduzione = action.payload;
    },
    setTipo: (state, action) => {
      state.tipo = action.payload;
    },
    setDenominazione: (state, action) => {
      state.denominazione = action.payload;
    },
    enumRequestStart: (state, action) => {
      state.enumsLoading[action.payload] = true;
      state.enumsError[action.payload] = null;
    },
    enumRequestSuccess: (state, action) => {
      state.enumsLoading[action.payload] = false;
    },
    enumRequestFailure: (state, action) => {
      const { enumType, error } = action.payload;
      state.enumsLoading[enumType] = false;
      state.enumsError[enumType] = error;
    }
  },
});

export const {
  setProdotti,
  addProdotto,
  addProdottoId,
  updateProdotto,
  deleteProdotto,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  enumRequestFailure,
  enumRequestStart,
  enumRequestSuccess,
  setTipo,
  setTipologia,
  setAnnoDiProduzione,
  setDenominazione,
  setSelectedProdottoId
} = prodottoSlice.actions;

// Fix the selectors to consistently use the same state path
export const selectProdotti = (state) => state.prodotto?.prodotti;
export const selectSingleProdotto = (state) => state.prodotto?.singleProdotti;
export const selectIsLoading = (state) => state.prodotto?.isLoading;
export const selectError = (state) => state.prodotto?.error;
export const selectTipologia = (state) => state.prodotto?.tipologia;
export const selectAnnoDiProduzione = (state) => state.prodotto?.annoDiProduzione;
export const selectTipo = (state) => state.prodotto?.tipo;
export const selectDenominazione = (state) => state.prodotto?.denominazione;
export const selectSelectedProdottoId = (state) => state.prodotto?.selectedProdottoId;

export default prodottoSlice.reducer;